(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    (function () {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form.classList || !form.classList.contains('contact-form__form')) {
        return;
      }
      var honeypot = form.querySelector('.contact-form__hp-field');
      if (honeypot && honeypot.value.trim() !== '') {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
